import Link from "next/link";
import { team_data } from "../../data/team_data";
import HeadLine from "../headLine";
import Image from "next/image";

const Team = () => {
  return (
    <div>
      {/* <!-- Team --> */}
      <section className="py-24">
        <div className="container">
          <HeadLine
            text="MEET OUR ADVISORS"
            classes="font-display text-5xl text-jacarta-700 dark:text-white lg:text-6xl xl:text-7xl text-center mb-4"
          />
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3 md:gap-[1.875rem] lg:grid-cols-5">
            {team_data.map((item) => {
              const { id, image, title, name, link } = item;
              return (
                <div
                  className="dark:bg-jacarta-700 rounded-2lg dark:border-jacarta-600 border-jacarta-100 border bg-white p-8 text-center transition-shadow hover:shadow-lg"
                  key={id}
                >
                  <Image
                    width={130}
                    height={130}
                    src={image}
                    className="rounded-2.5xl mx-auto mb-6 h-[8.125rem] w-[8.125rem] object-cover"
                    alt={name}
                  />
                  <h3 className="font-display text-jacarta-700 text-md dark:text-white">
                    {name}
                  </h3>
                  <span className="text-jacarta-400 text-2xs font-medium tracking-tight">
                    {title}
                  </span>

                  <div className="mt-3 flex justify-center space-x-5">
                    <Link href={link} className="group" target="_blank">
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fab"
                        data-icon="linkedin"
                        className="group-hover:fill-accent fill-jacarta-300 h-4 w-4 dark:group-hover:fill-white"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                      >
                        <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"></path>
                      </svg>
                    </Link>
                  </div>
                </div>
              );
            })}

            <Link
              href="/contact"
              className="dark:bg-jacarta-700 rounded-2lg dark:border-jacarta-600 border-jacarta-100 flex items-center justify-center border bg-white p-8 text-center transition-shadow hover:shadow-lg"
            >
              <span className="font-display text-jacarta-700 text-md dark:text-white uppercase">
                Join us!
              </span>
            </Link>
          </div>
        </div>
      </section>
      {/* <!-- end team --> */}
    </div>
  );
};

export default Team;
